export enum LanguageProficiency {
	Native = "Native",
	Fluent = "Fluent",
	Operational = "Operational"
}
